import React, { useEffect } from 'react'
import './App.css'
import AppRoutes from './routes/route';
import { ConfigProvider } from 'antd';
import { withLocalize } from "react-localize-redux";
import { AuthProvider } from './context/auth-context';
import { Provider } from 'react-redux';

import store from './redux';

const App = ({ activeLanguage }) => {

    useEffect(() => {
        document.documentElement.setAttribute(
            "dir",
            activeLanguage?.code === "ur" ? "rtl" : "ltr"
        );
    }, [activeLanguage]);


    return (
        <div className="background-img" style={{ height: '1000px' }}>
            <Provider store={store}>
                <ConfigProvider direction={activeLanguage.code === 'en' ? 'ltr' : 'rtl'}>
                    <AuthProvider>
                        <div className="container direction-components">
                            <AppRoutes />
                        </div>
                    </AuthProvider>
                </ConfigProvider>
            </Provider>
        </div>
    )
}

export default withLocalize(App);
